import React, { PureComponent, Fragment } from 'react';

import { AsyncImage } from 'components/asyncImage';
import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { FileImageRemoveModal, FileImageReplaceModal } from './FileImageModals';
import FileSection from './FileSection';
import FileUploading from './FileUploading';
import FileUploadingFailed from './FileUploadingFailed';

import { UPLOAD_STATUS } from '../constants';
import { getFileLink } from '../helpers';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

import './FileImageSection.scss';

@UploadConsumer()
export default class FileImageSection extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    mediaCode: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.number,
    timestamp: PropTypes.number,
    slim: PropTypes.bool,
    fileId: PropTypes.string,
    status: PropTypes.string,
    entityType: PropTypes.string,
    secondsLeft: PropTypes.number,
    progress: PropTypes.number,
    fileUpload: UploadProptypes.fileUpload
  };

  get fileUpload() {
    return this.props.fileUpload;
  }

  get fileId() {
    const { fileId, id } = this.props;

    return fileId || id;
  }

  get url() {
    return getFileLink(this.fileId);
  }

  render() {
    return (
      <FileSection className="file--image" slim={this.props.slim}>
        {this.renderChildren()}
      </FileSection>
    );
  }

  renderChildren() {
    const { status } = this.props;

    if (status === UPLOAD_STATUS.STARTED) {
      return this.renderProgress();
    } else if (status === UPLOAD_STATUS.FAILED) {
      return (
        <FileUploadingFailed
          big
          fileId={this.props.fileId}
          entityType={this.props.entityType}
        />
      );
    } else {
      return this.renderStandard();
    }
  }

  renderProgress() {
    const { progress, secondsLeft } = this.props;

    return (
      <FileUploading
        isBig
        hideLabel
        isShowingLoader
        progress={progress}
        remainingTime={secondsLeft}
      />
    );
  }

  renderStandard() {
    return (
      <Fragment>
        <FileSection.Header>
          <FileSection.Header.Info {...this.props} />

          <FileSection.Header.Actions
            FileRemoveModal={FileImageRemoveModal}
            FileReplaceModal={FileImageReplaceModal}
            replace={this.replace.bind(this)}
            remove={this.remove.bind(this)}
          />
        </FileSection.Header>

        <FileSection.Content half>
          {this.renderPreview()}
          {this.renderDescription()}
        </FileSection.Content>
      </Fragment>
    );
  }

  renderPreview() {
    return (
      <Grid block nomargin noborder nopadding half>
        <AsyncImage className="file__content__preview" url={this.url} />
      </Grid>
    );
  }

  renderDescription() {
    return (
      <Grid block nomargin noborder nopadding half>
        <label className="label__description mb__md mt__0">
          <I18n label="image_section.description" />
        </label>

        <label className="label__description mb__0">
          <I18n label="image_section.extension" />
        </label>
        <label className="label__description">
          <I18n label="image_section.size" />
        </label>
      </Grid>
    );
  }

  remove = () => {
    this.fileUpload && this.fileUpload.actions.delete(this.fileId);
  };

  replace = () => {
    this.fileUpload && this.fileUpload.actions.replace(this.fileId);
  };
}
